// First-impression copy shown by the root `grid` command. Kept in one
// module so the strings are unit-testable (index.ts runs the CLI on import and
// can't be imported in a test) and so a future polish pass has a single place
// to tune them. §23: plain, specific, confident, no marketing adjectives, no
// emoji, no exclamation marks.

/**
 * The one-line program description — the first thing a new builder sees when
 * they type `grid`. Concrete verb, no hedging about what isn't built yet.
 */
export const PROGRAM_DESCRIPTION = 'Put your apps and agents on the grid.';
